import { getCollectionFieldTraitOptions } from '../pluginComponentApi';
import { getBuilderConfigURL } from '../../../../common/utils/builder-config-url-util';
import { filterFieldsForDataTable } from '../../fields/FieldTypes';
import { hiddenFormField, SelectOptionFields } from 'drapcode-constant';
import { processSteps } from '../collectionForm/utils';
import {
  getCollectionOptionsForSelect,
  getExternalAPIOptionsForSelect,
} from '../pluginComponentApi';
const MAX_FIELD_COLUMNS = 10;

export default async function (editor, opt = {}) {
  const traitManager = editor.TraitManager;
  const { projectId, collections, bindCollectionOptions, token, externalApis, version } = opt;
  let externalAPIList = externalApis.filter(
    (externalAPI) =>
      externalAPI.responseDataMapping &&
      externalAPI.responseDataMapping.selectedCollectionName !== '',
  );
  let { collection: pageCollection } = bindCollectionOptions;
  let innerFieldOptions = [];
  if (pageCollection) {
    const { collectionId } = pageCollection;
    pageCollection = collections.find((col) => col.collectionName === collectionId);
    const innerFields = pageCollection
      ? pageCollection.fields.filter((field) => SelectOptionFields.includes(field.type))
      : [];
    innerFieldOptions =
      innerFields.map((field) => {
        return { value: field.fieldName, name: field.fieldTitle.en };
      }) || [];
  }

  const style = document.createElement('style');
  style.innerHTML = `
  .checkmark::after {
    left: 4px;
    top: 4px;
  }

  checkbox {
    all: unset;
  }

  select option:first-child {
    color: grey;
  }

  select.empty {
    color: grey;
  }

  select option[disabled]:first-child {
    display: none;
  }

  input[type=webconnect-text] {
    display: block;
  }

  input[type=webconnect-link] {
    display: block;
  }
  `;
  document.head.appendChild(style);
  if (collections || innerFieldOptions) {
    traitManager.addType('dt-dynamic-collection', {
      createInput({ trait }) {
        const el = document.createElement('div');
        el.classList.add('custom-field');
        el.innerHTML = `    
      <div class="row settings--progress-bar">
        <div class="container">
          <div class="progress">
            <div class="progress-bar"></div>
          </div>
        </div>
      </div>
      <hr/>
      <div id="URL" class="settings--progress">
      ${
        collections || pageCollection
          ? `
          <div class="gjs-container">
            <div class="gjs-row mx-auto">
              <div class="badge badge-default cms--progress--step-1">
                <i class="wb webconnect"></i>
                <span class="step--desc">Step 1: Select Get Content From</span>
              </div>
            </div>
            <div class="gjs-row">
            <div class="gjs-label-wrp d-none">
            <div class="gjs-label" title="Get Content">Get Content</div>
          </div>
            <div id="select-getContentFrom-div" class="gjs-field-wrp gjs-field-wrp--select-getContentFrom">
              <div class="gjs-field">
                <select class="select-getContentFrom form-control form-control-sm options-light">
                  <option value="">- Get Content -</option>
                  ${
                    collections
                      ? `
                      <option value="collections">Get Data From Collection</option>
                            `
                      : ''
                  }
                </select>
                </div>
              </div>
            </div>
          </div>
          `
          : ''
      }

    <div class="gjs-container cms-data-container" style="display: none">
      <div class="gjs-row mx-auto pb-0" style="justify-content: space-between;">
        <div class="badge badge-default cms--progress--step-2">
          <i class="wb webconnect"></i>
          <span class="step--desc">Step 2: Select Collection / Field</span>
        </div>
        <div class="cms-create-collection-container" style="display: none;flex-grow: 1;">
          <div class="gjs-row" style="flex-direction: row-reverse;">
            <a href=${getBuilderConfigURL()}collections/${version}/v/${projectId}/create?token=${token} class="direction-custom-link btn btn-outline-light py-0 px-1">
              <i class="wb webconnect-box-arrow-up-right"></i>&nbsp;Create Collection
            </a>
          </div>
        </div>
      </div>
      <div class="gjs-row">
        <div class="gjs-label-wrp d-none">
          <div class="gjs-label select-cms-data-label" title="Collection">Collection</div>
        </div>
        <div id="select-cms-data-div" class="gjs-field-wrp gjs-field-wrp--select-cms-data">
          <div id="select-field-div" style="display: none" class="gjs-field">
            <select class="selectField form-control form-control-sm options-light">
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="gjs-container cms-external-api-container" style="display: none">
      <div class="gjs-row mx-auto pb-0" style="justify-content: space-between;">
        <div class="badge badge-default cms--progress--step-2">
          <i class="wb webconnect"></i>
          <span class="step--desc">Step 2: Select External API</span>
        </div>
        <div class="create-external-api-container" style="display: none;flex-grow: 1;">
          <div class="gjs-row" style="flex-direction: row-reverse;">
            <a href=${getBuilderConfigURL()}externalapi/${version}/v/${projectId}/create?token=${token} class="direction-custom-link btn btn-outline-light py-0 px-1">
              <i class="wb webconnect-box-arrow-up-right"></i>&nbsp;Create ExternalAPI
            </a>
          </div>
        </div>
      </div>
      <div class="gjs-row">
        <div class="gjs-label-wrp d-none">
          <div class="gjs-label select-external-api-label" title="External API">External API</div>
        </div>
        <div id="select-external-api-div" class="gjs-field-wrp gjs-field-wrp--select-external-api">
          <div id="select-external-api-field-div" style="display: none" class="gjs-field">
            <select class="selectExternalApiField form-control form-control-sm options-light">
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="gjs-container cms-filter-container pb-0" style="display: none">
      <div class="gjs-row mx-auto pb-0">
        <div class="badge badge-default cms--progress--step-3">
          <i class="wb webconnect"></i>
          <span class="step--desc">Step 3: Select Filter (Optional)</span>
        </div>
      </div>
    </div>
     <div class="form-group filter-div" style="display: none">
        <select class="filter-select form-control form-control-sm options-light">
        </select>
     </div>
    </div>
    `;
        const cmsDataContainer = el.querySelector('.cms-data-container');
        const cmsCreateCollectionContainer = el.querySelector('.cms-create-collection-container');
        const selectFieldDiv = el.querySelector('#select-field-div');
        const selectField = el.querySelector('.selectField');
        const selectExternalApiField = el.querySelector('.selectExternalApiField');
        const selectGetContentFrom = el.querySelector('.select-getContentFrom');
        const cmsFilterContainer = el.querySelector('.cms-filter-container');
        const cmsExternalAPIContainer = el.querySelector('.cms-external-api-container');
        const cmsCreateExternalAPIContainer = el.querySelector('.create-external-api-container');

        selectGetContentFrom.addEventListener('change', async (ev) => {
          selectField.innerHTML = '';
          let optionHtml = `<option value="">None</option>`;
          selectFieldDiv.style.display = 'block';

          if (selectGetContentFrom.value === 'externalApiResponse') {
            cmsCreateCollectionContainer.style.display = 'none';
            cmsDataContainer.style.display = 'none';
            cmsCreateExternalAPIContainer.style.display = 'block';
            cmsExternalAPIContainer.style.display = 'block';
          } else {
            cmsCreateCollectionContainer.style.display = 'block';
            cmsDataContainer.style.display = 'block';
            cmsCreateExternalAPIContainer.style.display = 'none';
            cmsExternalAPIContainer.style.display = 'none';
          }

          if (['collections', 'browserSession'].includes(selectGetContentFrom.value)) {
            optionHtml = getCollectionOptionsForSelect(collections);
          } else if (selectGetContentFrom.value === 'externalApiResponse') {
            selectExternalApiField.innerHTML = getExternalAPIOptionsForSelect(externalAPIList);
          } else if (selectGetContentFrom.value === 'innerFields') {
            optionHtml = `<option value="" selected>- Select Field -</option>`;
            optionHtml += `${innerFieldOptions
              .map((opt) => `<option value="${opt.value}">${opt.name}</option>`)
              .join('')}`;
          } else {
            cmsCreateCollectionContainer.style.display = 'none';
            cmsDataContainer.style.display = 'none';
            selectFieldDiv.style.display = 'none';
            cmsFilterContainer.style.display = 'none';
            cmsCreateExternalAPIContainer.style.display = 'none';
            cmsExternalAPIContainer.style.display = 'none';
          }
          selectField.innerHTML = optionHtml;
        });

        return el;
      },
      async onEvent({ elInput, component }) {
        const compAttributes = component.getAttributes();
        const traitName = this.model.get('name');
        const select = elInput.querySelector('.selectField');
        const filterDiv = elInput.querySelector('.filter-div');
        const filterSelect = elInput.querySelector('.filter-select');
        const selectGetContentFrom = elInput.querySelector('.select-getContentFrom');
        const cmsDataLabel = elInput.querySelector('.select-cms-data-label');
        const cmsProgressBarContainer = document.querySelector('.settings--progress-bar');
        const cmsProgressStep = document.querySelector('.settings--progress');
        const cmsFilterContainer = document.querySelector('.cms-filter-container');

        const selectExternalApiFieldDiv = elInput.querySelector('#select-external-api-field-div');
        const selectExternalApiField = elInput.querySelector('.selectExternalApiField');

        if (selectGetContentFrom.value) {
          processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepOne');
          component.addAttributes({
            'data-cs-contentFrom': selectGetContentFrom.value,
          });
          cmsDataLabel.innerHTML = 'Collection';
        } else {
          processSteps(cmsProgressStep, false, cmsProgressBarContainer, 'stepOne');
          component.addAttributes({
            'data-cs-contentFrom': '',
          });
        }

        let selectedCollectionData;
        let collectionName;

        if (selectGetContentFrom.value && select.value) {
          if (selectGetContentFrom.value === 'collections') {
            component.addAttributes({
              'data-cs-fieldName': '',
            });
            collectionName = select.value;
            selectedCollectionData = collections.find(
              (coll) => collectionName === coll.collectionName,
            );
            component.addAttributes({
              'data-cs-collectionName': collectionName,
            });
            let fieldOptions = await getCollectionFieldTraitOptions(
              selectedCollectionData,
              collections,
            );
            fieldOptions = filterFieldsForDataTable(fieldOptions);
            let options = [{ value: '', name: '- Select Field -' }];
            fieldOptions = [...options, ...fieldOptions];
            fieldOptions.map((field, index) => {
              if (index && index <= MAX_FIELD_COLUMNS) {
                const colIndex = index;
                const colTrait = component.getTrait(`data-cs-column-${colIndex}`);
                if (!colTrait) {
                  component.addTrait({
                    type: 'select',
                    label: `Column ${colIndex}`,
                    name: `data-cs-column-${colIndex}`,
                    options: fieldOptions,
                  });
                } else {
                  colTrait.set('options', fieldOptions);
                }
              }
            });

            const finderOptions = selectedCollectionData
              ? selectedCollectionData.finders.map((finder) => {
                  return { value: finder.uuid, name: finder.name };
                })
              : [];
            const findAllFinder = selectedCollectionData
              ? selectedCollectionData.finders.find(
                  (finder) => finder.name === 'Find All' || finder.name === 'All Items',
                ).uuid
              : '';
            const filterTrait = component.getTrait('data-cs-finderUuid');
            if (collectionName && findAllFinder) {
              component.addAttributes({
                'data-cs-finderUuid': findAllFinder,
              });
            } else {
              component.addAttributes({
                'data-cs-finderUuid': '',
              });
            }

            if (!filterTrait) {
              component.addTrait(
                {
                  type: 'select',
                  label: false,
                  name: 'data-cs-finderUuid',
                  options: finderOptions,
                },
                { at: component.getTraitIndex('collectionName') + 1 },
              );
            } else {
              filterTrait.set('options', finderOptions);
            }
          }

          const finderUuid = compAttributes ? component.getAttributes()['data-cs-finderUuid'] : '';

          const sessionDataPath = compAttributes
            ? component.getAttributes()['data-cs-sessionDataPath']
            : '';
          if (finderUuid) {
            processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepThree');
            cmsFilterContainer.style.display = 'block';
          } else if (sessionDataPath) {
            processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepThree');
            cmsFilterContainer.style.display = 'block';
          } else {
            cmsFilterContainer.style.display = 'none';
          }
        } else if (
          selectGetContentFrom.value &&
          selectGetContentFrom.value === 'externalApiResponse'
        ) {
          component.addAttributes({
            'data-cs-fieldName': '',
            'data-cs-finderUuid': '',
            'data-cs-contentFrom': 'externalAPIResponse',
          });

          const filterTrait = component.getTrait('data-cs-finderUuid');
          if (filterTrait) {
            component.removeTrait('data-cs-finderUuid');
          }
          const sessionDataPathTrait = component.getTrait('data-cs-sessionDataPath');
          if (sessionDataPathTrait) {
            component.removeTrait('data-cs-sessionDataPath');
          }

          selectExternalApiFieldDiv.style.display = 'block';
          const selectedExternalAPI = selectExternalApiField.value
            ? externalAPIList.find(
                (externalAPI) => externalAPI.uuid === selectExternalApiField.value,
              )
            : '';
          const externalAPIResponseCollection = selectedExternalAPI
            ? selectedExternalAPI.responseDataMapping.selectedCollectionName
            : '';
          collectionName = externalAPIResponseCollection ? externalAPIResponseCollection : '';
          selectedCollectionData = collections.find(
            (coll) => collectionName === coll.collectionName,
          );

          if (selectedCollectionData) {
            selectedCollectionData.externalApiId = '';
          }

          const responseDataMappingFields = [];
          if (
            selectedExternalAPI.responseDataMapping &&
            selectedExternalAPI.responseDataMapping.selectedMapping
          ) {
            selectedCollectionData.fields.forEach((element) => {
              if (hiddenFormField.includes(element.fieldName)) {
                responseDataMappingFields.push(element);
              }
              if (
                selectedExternalAPI.responseDataMapping.selectedMapping[element.fieldName] &&
                !element.fieldName.startsWith('_')
              ) {
                responseDataMappingFields.push(element);
              }
            });
          }
          cmsFilterContainer.style.display = 'none';
          let collectionDataStr = selectedCollectionData
            ? JSON.stringify(selectedCollectionData)
            : '';
          collectionDataStr = collectionDataStr ? collectionDataStr.replaceAll('"', '**##') : '';
          component.addAttributes({
            'data-cs-collectionName': collectionName,
          });
        } else {
          cmsDataLabel.innerHTML = '';
          component.addAttributes({
            'data-cs-collectionName': '',
            'data-cs-fieldName': '',
            'data-cs-finderUuid': '',
            'data-cs-externalAPIResponseDataMapping': '',
            'data-cs-externalApiData': '',
            'data-cs-externalAPIResponseDataMappingFields': '',
          });

          const filterTrait = component.getTrait('data-cs-finderUuid');
          if (filterTrait) {
            component.removeTrait('data-cs-finderUuid');
          }
          const sessionDataPathTrait = component.getTrait('data-cs-sessionDataPath');
          if (sessionDataPathTrait) {
            component.removeTrait('data-cs-sessionDataPath');
          }

          processSteps(cmsProgressStep, false, cmsProgressBarContainer);
          if (!select.value && selectGetContentFrom.value) {
            processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepOne');
            processSteps(cmsProgressStep, false, cmsProgressBarContainer, 'stepTwo');
            cmsFilterContainer.style.display = 'none';
          } else {
            component.addAttributes({
              'data-cs-contentFrom': '',
            });
          }
        }
      },
      async onUpdate({ elInput, component }) {
        const compAttributes = component.getAttributes();
        const collectionName = compAttributes
          ? component.getAttributes()['data-cs-collectionName']
          : '';
        const fieldName = compAttributes ? component.getAttributes()['data-cs-fieldName'] : '';
        const finderUuid = compAttributes ? component.getAttributes()['data-cs-finderUuid'] : '';
        const contentFrom = compAttributes ? component.getAttributes()['data-cs-contentFrom'] : '';

        let definedColumns = [];

        const cmsProgressBarContainer = elInput.querySelector('.settings--progress-bar');
        const cmsProgressStep = elInput.querySelector('.settings--progress');

        const cmsDataContainer = elInput.querySelector('.cms-data-container');
        const cmsCreateCollectionContainer = elInput.querySelector(
          '.cms-create-collection-container',
        );
        const cmsDataLabel = elInput.querySelector('.select-cms-data-label');
        const cmsFilterContainer = elInput.querySelector('.cms-filter-container');

        const cmsExternalAPIContainer = elInput.querySelector('.cms-external-api-container');
        const cmsCreateExternalAPIContainer = elInput.querySelector(
          '.create-external-api-container',
        );

        const selectFieldDiv = elInput.querySelector('#select-field-div');
        const selectField = elInput.querySelector('.selectField');
        const selectGetContentFrom = elInput.querySelector('.select-getContentFrom');

        const selectExternalApiFieldDiv = elInput.querySelector('#select-external-api-field-div');
        const selectExternalApiField = elInput.querySelector('.selectExternalApiField');

        let selectedCollectionData = collectionName
          ? collections.find((coll) => coll.collectionName === collectionName)
          : '';
        let fieldOptions = await getCollectionFieldTraitOptions(
          selectedCollectionData,
          collections,
        );
        fieldOptions = filterFieldsForDataTable(fieldOptions);
        let options = [{ value: '', name: '- Select Field -' }];
        fieldOptions = [...options, ...fieldOptions];

        compAttributes &&
          Object.entries(compAttributes).map(([key, value], index) => {
            if (key.startsWith('data-cs-column')) {
              const order = key.replace(/data-cs-column-(.*?)/g, '$1');
              definedColumns.push({ order: Number(order), column: value });
            }
          });

        if (contentFrom) {
          selectGetContentFrom.value = contentFrom;
          processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepOne');
          cmsDataLabel.innerHTML = contentFrom
            ? contentFrom === 'collections'
              ? 'Collection'
              : 'Collection Field'
            : '';
        }

        if (
          contentFrom &&
          ['collections', 'externalAPIResponse'].includes(contentFrom) &&
          collectionName
        ) {
          processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepTwo');
          if (contentFrom === 'collections') {
            let optionHtml = `<option value="">- Select Collection -</option>`;
            selectFieldDiv.style.display = 'block';
            cmsDataContainer.style.display = 'block';
            cmsCreateCollectionContainer.style.display = 'block';
            cmsFilterContainer.style.display = 'block';
            optionHtml = getCollectionOptionsForSelect(collections);
            selectField.innerHTML = optionHtml;
            selectField.value = collectionName;

            const finderOptions = selectedCollectionData
              ? selectedCollectionData.finders.map((finder) => {
                  return { value: finder.uuid, name: finder.name };
                })
              : [];

            const filterTrait = component.getTrait('data-cs-finderUuid');
            if (!filterTrait) {
              component.addTrait(
                {
                  type: 'select',
                  label: false,
                  name: 'data-cs-finderUuid',
                  options: finderOptions,
                },
                { at: component.getTraitIndex('collectionName') + 1 },
              );
            } else {
              filterTrait.set('options', finderOptions);
            }
            if (finderUuid) {
              processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepThree');
            }
          }
        } else {
          processSteps(cmsProgressStep, false, cmsProgressBarContainer);
        }

        fieldOptions.map((field, index) => {
          if (index && index <= MAX_FIELD_COLUMNS) {
            const colIndex = index;
            const colTrait = component.getTrait(`data-cs-column-${colIndex}`);
            if (!colTrait) {
              component.addTrait({
                type: 'select',
                label: `Column ${colIndex}`,
                name: `data-cs-column-${colIndex}`,
                options: fieldOptions,
              });
            } else {
              colTrait.set('options', fieldOptions);
            }
          }
        });

        if (!collectionName) {
          processSteps(cmsProgressStep, false, cmsProgressBarContainer);
          if (contentFrom) {
            processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepOne');
          }

          //Reset Column Traits and Attributes
          definedColumns &&
            Object.entries(definedColumns).map(([key, definedColumn], index) => {
              if (definedColumn) {
                const columnTrait = component.getTrait(`data-cs-column-${definedColumn.order}`);
                if (columnTrait) {
                  component.removeTrait(`data-cs-column-${definedColumn.order}`);
                }
                delete compAttributes[`data-cs-column-${definedColumn.order}`];
                component.setAttributes(compAttributes);
              }
            });

          const traits = component.get('traits');
          let toRemoveFields = [];

          traits.forEach((trait) => {
            if (trait.props().name.startsWith('data-cs-column-')) {
              toRemoveFields.push(trait.props().name);
            }
          });

          //Reset Column Traits and Attributes
          toRemoveFields &&
            toRemoveFields.forEach((toRemoveField) => {
              if (toRemoveField) {
                const columnTrait = component.getTrait(toRemoveField);
                if (columnTrait) {
                  component.removeTrait(toRemoveField);
                }
                delete compAttributes[toRemoveField];
                component.setAttributes(compAttributes);
              }
            });
        }
      },
    });
  }
}
